import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import CheckboxWLabel from '../../../../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import FileUpload from '../../../../../components/fileupload/FileUpload';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import Icons from '../../../../../components/icons/Icons';
import Loadable from '../../../../../components/loadable/Loadable';
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import { checkUseSavedOrStartNewImport, continueWithSavedData, downloadBatchImportTemplate, submitBatchImportMatchedFields, submitFileOrPastedData, uploadFile } from '../../BatchImportSaga';
import { updateBatchImportFormData, setIsQuarterSelectionPopupOpen, setQuarterSelectionPopupTriggeredByModule } from '../../BatchImportSlice';
import QuarterSelectionPopup from '../../components/quarterselectionpopup/QuarterSelectionPopup';
import { BATCH_FORMS_LOADING_STATES, BATCH_FORM_STATES_MESSAGE_MAP, QUARTER_SELECTION_FROM } from '../../constants';
import styles from './UploadFile.styles';

export default function UploadFileView({ loadingState, batchImportFormData, setRefreshStep = () => {}, formSettings, isQuarterSelectionPopupOpen, quarterSelectionPopupTriggeredByModule}) {
	const [currentSelectedFileTypeForDownload, setCurrentSelectedFileTypeForDownload] = useState(null);
	const [selectedQuarterFromPopupForDownloadTemplate, setSelectedQuarterFromPopupForDownloadTemplate] = useState(null);
	const [isQuarterValueForMatchingFieldsStepSetForFileView, setIsQuarterValueForMatchingFieldsStepSetForFileView] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		if(batchImportFormData.goToListingStep){
			setRefreshStep(2);
			dispatch(updateBatchImportFormData({goToListingStep: null}));
		}
	}, [batchImportFormData.goToListingStep]);

	useEffect(() => {
		if(batchImportFormData.isUploadedDataSessionSet){
			if(formSettings?.showMappingPageFlag){
				setRefreshStep(1);
			}else{
				dispatch(submitBatchImportMatchedFields({
					formId: batchImportFormData?.selectedForm?.FormId, 
					matchedFieldsData: {}, 
					year: batchImportFormData?.selectedYear ?? null, 
					quarter: batchImportFormData?.quarter,
					pageLoadingState: {
						loading: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING,
						ready: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY,
					}
				}));
			}
		}
	}, [batchImportFormData.isUploadedDataSessionSet]);

	useEffect(() => {
		if(selectedQuarterFromPopupForDownloadTemplate !== null){
			dispatchDownloadBatchImportTemplate(selectedQuarterFromPopupForDownloadTemplate, currentSelectedFileTypeForDownload);
		}
		setSelectedQuarterFromPopupForDownloadTemplate(null);
	}, [selectedQuarterFromPopupForDownloadTemplate]);

	useEffect(() => {
		if(isQuarterValueForMatchingFieldsStepSetForFileView){
			dispatchFileOrPastedData(batchImportFormData, "File");
			setIsQuarterValueForMatchingFieldsStepSetForFileView(null);
		}
	}, [isQuarterValueForMatchingFieldsStepSetForFileView]);

	const handleFileUpload = (event) => {
		event.preventDefault();
		const file = event.target.files[0];
		const fileExtension = file.name.split('.').pop().toLowerCase();

		if (formSettings?.allowedFileType.includes(`.${fileExtension}`)) {
			dispatch(updateBatchImportFormData({ uploadedFile: file }));
			if (file) {
				if(formSettings?.checkForSavedDataFlag){
					dispatch(checkUseSavedOrStartNewImport({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: file, year: batchImportFormData?.selectedYear ?? null}));
				}else{
					dispatch(uploadFile({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: file, year: batchImportFormData?.selectedYear ?? null}))
				}
			}
		} else {
			dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
		}
		event.target.value = null;
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const file = event.dataTransfer.files[0];
		const fileExtension = file.name.split('.').pop().toLowerCase();

		if (formSettings?.allowedFileType.includes(`.${fileExtension}`)) {
			dispatch(updateBatchImportFormData({uploadedFile: file}));
			if (file) {
				if(formSettings?.checkForSavedDataFlag){
					dispatch(checkUseSavedOrStartNewImport({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: file, year: batchImportFormData?.selectedYear ?? null}));
				}else{
					dispatch(uploadFile({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: file, year: batchImportFormData?.selectedYear ?? null}))
				}
			}
		} else {
			dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
		}
	};

	const dispatchFileOrPastedData = (batchImportFormData, mode) => {
		dispatch(submitFileOrPastedData({
			formId: batchImportFormData?.selectedForm?.FormId ?? null, 
			data: {
				Mode : mode,
				IsCorrected : batchImportFormData.filingForCorrected,
				Data : "",
				TaxYear : batchImportFormData.selectedYear
			}, 
			year: batchImportFormData?.selectedYear ?? null,
			actionLoadingState: {
                loading: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING,
                ready: BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_READY,
            }
		}));
	}

	const handleGoToNxtStepBtnClick = (batchImportFormData, mode) => {
		if(formSettings?.quarterOptions && (formSettings?.quarterOptions).length > 0){
			dispatch(setIsQuarterSelectionPopupOpen(true));
			dispatch(setQuarterSelectionPopupTriggeredByModule(QUARTER_SELECTION_FROM.GOTONEXTSTEPFROMFILEUPLOADSTEP));
		}else{
			dispatchFileOrPastedData(batchImportFormData, mode);
		}
	}

	const handleDownloadTemplateBtnClk = (fileFormat) => {
		if(formSettings?.quarterOptions && (formSettings?.quarterOptions).length > 0){
			setCurrentSelectedFileTypeForDownload(fileFormat);
			dispatch(setIsQuarterSelectionPopupOpen(true));
			dispatch(setQuarterSelectionPopupTriggeredByModule(QUARTER_SELECTION_FROM.DOWNLOAD_TEMPLATE));
		}else{
			dispatchDownloadBatchImportTemplate(null, fileFormat);
		}
	}

	const dispatchDownloadBatchImportTemplate = (selectedQuarterFromPopupForDownloadTemplate = null, currentSelectedFileTypeForDownload) => {
		dispatch(downloadBatchImportTemplate({
			formId: batchImportFormData?.selectedForm?.FormId ?? null, 
			year: batchImportFormData?.selectedYear ?? null, 
			fileType: currentSelectedFileTypeForDownload,
			quarter: selectedQuarterFromPopupForDownloadTemplate
		}));
	}

	const handleQuarterSelectionConfirmationClick = (quarterValue) => {
		if(quarterSelectionPopupTriggeredByModule === QUARTER_SELECTION_FROM.DOWNLOAD_TEMPLATE){
			setSelectedQuarterFromPopupForDownloadTemplate(quarterValue);
			dispatch(setQuarterSelectionPopupTriggeredByModule(null));
		}else{
			dispatch(updateBatchImportFormData({
				quarter: quarterValue,
			}));
			setIsQuarterValueForMatchingFieldsStepSetForFileView(true);
			dispatch(setQuarterSelectionPopupTriggeredByModule(null));
		}
		dispatch(setIsQuarterSelectionPopupOpen(false));
	}

	return <>
		<Loadable
            currentState={loadingState.state} 
            loadingStates={[BATCH_FORMS_LOADING_STATES.STEP1_PAGE_LOADING, BATCH_FORMS_LOADING_STATES.UPLOAD_FILE_PAGE_LOADING ]} 
            messageMap={BATCH_FORM_STATES_MESSAGE_MAP}
            isNewLoadable={true}
        >
			{
				formSettings?.allowedFileType.includes(".txt") && <div style={styles.txtFileFormatNoticeText}>
					Exciting news! Tax1099 has expanded its support to include the IRS 1220 format .txt file. Enjoy a hassle-free filing experience by clicking 'Select Files' and uploading your 1220 format .txt file. For smooth processing, remember to retain only A, B and K records, excluding T, C, and F records. Simplify your tax filing process with Tax1099!
				</div>
			}
			<div style={styles.uploadScreenContainer}>
				<FileUpload
					uploadedFile={batchImportFormData?.uploadedFile}
					onDropCb={handleDrop}
					title={formSettings?.allowedFileType.includes(".txt") ? "Upload the Excel /.txt file" : "Upload the Excel file"}
					templatesForDownload={(formSettings?.allowedFileType ?? []).filter(type => type !== '.txt').map(type => (
						{
							templateText: type,
							downloadTemplateCb: () => {
								handleDownloadTemplateBtnClk(type.split(".").join(""));
							},
						}
					))}
					allowedFileType={formSettings?.allowedFileType ?? []}
					onInputChangeCb={handleFileUpload}
					containerBodyCustomStyles={styles.uploadContainerBodyCustomStyles}
				/>
				{
					formSettings?.showCorrectedReturnCheckBox && <div style={styles.correctedCheckboxDiv}>
						<CheckboxWLabel label="Check if filing for corrected" checked={batchImportFormData?.filingForCorrected} onChangeCb={() => { dispatch(updateBatchImportFormData({ filingForCorrected: !batchImportFormData?.filingForCorrected })) }} />
					</div>
				}
				<div style={styles.noteTextContainer}>
					<span style={styles.noteIcon}>
						<Icons iconName={VEC_ICON_NAME.INFO_ICON} familyName="vec" />
					</span>
					<span style={styles.noteText}>If you are using an excel file based on data exported from the View/Edit/Submit or Manage Forms pages, please review the steps below,</span>
					<ol type="i">
						<li>
							<b style={styles.noteTextBold}>Exported from View/Edit/Submit page:</b> Please remove the columns named “Corrected” and “Form Status” before you attempt the import.
						</li>
						<li>
							<b style={styles.noteTextBold}>Exported from Manage Forms page:</b> Please remove the columns named “Corrected”, “Form Status”, and “Reference Number” before you attempt the import.
						</li>
					</ol>

				</div>
				<div style={styles.mainButtonsContainer}>
					{
						formSettings?.checkForSavedDataFlag && <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(checkUseSavedOrStartNewImport({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: null, year: batchImportFormData?.selectedYear ?? null}))}>
						Check saved data
					</Button>
					}
					{batchImportFormData?.useUploadedFile ?
						<Button type={BUTTON_TYPE.PRIMARY} style={styles.nextButtonStyles} onClickCb={() => handleGoToNxtStepBtnClick(batchImportFormData, "File")}>
							Next
						</Button>
						: null
					}
				</div>
			</div>
			{
				batchImportFormData?.isPreviousSavedData !== null ?
					<ConfirmationPopup
						title={"What would you like to do?"}
						bodyText={"Would you like to use the saved data you have been working on or start a new import?"}
						iconName = {VEC_ICON_NAME.WARNING_ICON}
						isOpen={batchImportFormData?.isPreviousSavedData ?? false}
						confirmationButtonProps = {{
							onConfirmationCb: () => dispatch(continueWithSavedData({formId: batchImportFormData?.selectedForm?.FormId ?? null, year: batchImportFormData?.selectedYear ?? null})),
							confirmationButtonText: "Use saved data",
							confirmationButtonStyles: {},
							confirmationButtonType: BUTTON_TYPE.PRIMARY,
						}}
						cancelButtonProps = {{
							onCancelCb: () => batchImportFormData?.uploadedFile !== null ? dispatch(uploadFile({formId: batchImportFormData?.selectedForm?.FormId ?? null, modifiedFile: batchImportFormData?.uploadedFile, year: batchImportFormData?.selectedYear ?? null})) : dispatch(updateBatchImportFormData({isPreviousSavedData: null})),
							cancelButtonText: "Start new import",
							cancelButtonStyles: {},
							cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
						} }
						showClose={false}
					/>
				: null
			}
			{
				isQuarterSelectionPopupOpen && <QuarterSelectionPopup 
					isOpen={isQuarterSelectionPopupOpen}
					confirmationButtonProps = {{
						onConfirmationCb: (quarterValue) => {
							handleQuarterSelectionConfirmationClick(quarterValue);
						},
						confirmationButtonText: "Ok",
						confirmationButtonStyles: {},
						confirmationButtonType: BUTTON_TYPE.PRIMARY,
					}}
					cancelButtonProps = {{
						onCancelCb: () => dispatch(setIsQuarterSelectionPopupOpen(false)),
						cancelButtonText: "Cancel",
						cancelButtonStyles: {},
						cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
					}}
					quarterOptions={formSettings?.quarterOptions}
				/>
			}
		</Loadable>
	</>
}